import styled from 'styled-components';


export const Main = styled.main`
  background-color: var(--color-background);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  >div {
    padding: 64px 0px;
    border-bottom: 5px solid var(--color-gray);
  }

  >div:last-child{
    border:none;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  max-width: 70%;
  
  >div {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 50%;
    padding: 16px;

    >h1:first-child {
      font-family: 'Expansiva', sans-serif;
      font-size: 24px;
      line-height: 40px;
      text-align: center;
      border-bottom: 5px solid var(--color-gray);
      padding-bottom: 35px;
    }

    >p, ul {
      padding: 0 16px;
      padding-top: 35px;
      font-size: 16px;
      line-height: 28px;
      text-align: justify;
      
      a {
        cursor: pointer;
        color: var(--color-gray);
        text-decoration: none;

      &:hover{
        text-decoration: underline;
        }
      }
    }

    img {
      padding: 32px;
    }

    @media screen and (max-width: 960px) {
      padding: 16px;
    }
  }

  @media screen and (max-width: 960px) {
    flex-wrap: wrap;

    img {
      width: 320px;
    }
  }
`;
